// Free geocoding: Photon (komoot) first, Nominatim fallback (≤1 req/s). No API keys.
const COORD_RE = /^\s*(-?\d{1,2}(?:\.\d+)?)\s*[, ]\s*(-?\d{1,3}(?:\.\d+)?)\s*$/;

export const parseCoords = (q) => {
  const m = COORD_RE.exec(q || "");
  if (!m) return null;
  const lat = +m[1], lng = +m[2];
  return Math.abs(lat) <= 90 && Math.abs(lng) <= 180 ? { lat: +lat.toFixed(6), lng: +lng.toFixed(6) } : null;
};

const photon = async (q, center, signal) => {
  const u = new URL("https://photon.komoot.io/api/");
  u.searchParams.set("q", q); u.searchParams.set("limit", "6"); u.searchParams.set("lang", "en");
  if (center) { u.searchParams.set("lat", center.lat); u.searchParams.set("lon", center.lng); }
  const r = await fetch(u, { signal });
  if (!r.ok) throw new Error(`photon ${r.status}`);
  const j = await r.json();
  return (j.features || []).map((f) => {
    const p = f.properties || {};
    const street = [p.housenumber, p.street].filter(Boolean).join(" ");
    const name = p.name || street || p.city || p.country || "Unnamed place";
    const secondary = [name !== street ? street : null, p.district, p.city || p.town || p.village, p.state, p.country].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).join(", ");
    return { id: `p-${p.osm_id || Math.random()}`, name, secondary, lat: f.geometry.coordinates[1], lng: f.geometry.coordinates[0], label: street && p.name ? `${p.name}, ${street}` : name };
  });
};

let lastNominatim = 0;
const nominatim = async (q, signal) => {
  const wait = 1100 - (Date.now() - lastNominatim);
  if (wait > 0) await new Promise((r) => setTimeout(r, wait));
  lastNominatim = Date.now();
  const u = new URL("https://nominatim.openstreetmap.org/search");
  u.searchParams.set("format", "jsonv2"); u.searchParams.set("q", q); u.searchParams.set("limit", "6"); u.searchParams.set("accept-language", "en");
  const r = await fetch(u, { signal, headers: { Accept: "application/json" }, referrerPolicy: "origin" });
  if (!r.ok) throw new Error(`nominatim ${r.status}`);
  const j = await r.json();
  return j.map((x) => {
    const parts = (x.display_name || "").split(", ");
    return { id: `n-${x.place_id}`, name: x.name || parts[0], secondary: parts.slice(1, 4).join(", "), lat: +x.lat, lng: +x.lon, label: x.name || parts[0] };
  });
};

export const geocode = async (q, center, signal) => {
  try { return { results: await photon(q, center, signal), source: "photon" }; }
  catch (e) { if (e.name === "AbortError") throw e; return { results: await nominatim(q, signal), source: "nominatim" }; }
};
